export default __webpack_public_path__ + "static/people-ac4a414f87332fdaedfb9325edb63a6e.jpg";